import React from 'react'
import { Tooltip, TooltipProps, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useLoginPopover } from './loginPopoverContext'

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    padding: theme.spacing(2),
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    boxShadow: theme.shadows[4],
  },
  arrow: {
    color: theme.palette.background.default,
  },
}))

interface LoginPopoverProps {
  placement?: TooltipProps['placement']
  children: React.ReactElement<any, any>
}

const LoginPopover: React.FC<LoginPopoverProps> = ({
  placement = 'bottom',
  children,
}) => {
  const classes = useStyles()
  const { loginPopover } = useLoginPopover()

  return !!loginPopover ? (
    <Tooltip
      open
      placement={placement}
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      interactive
      arrow
      title={loginPopover}
    >
      {children}
    </Tooltip>
  ) : (
    children
  )
}

export default LoginPopover
